/* eslint-disable react-hooks/exhaustive-deps */
import Axios from 'axios';
import publicIp from 'public-ip';
import React, { useCallback, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { DIV } from 'src/components/CustomStyledComponents';
import FooterButton from 'src/components/FooterBtn/FooterButton';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import InputsDinamicos from 'src/components/InputsDinamicos';
import UniqueKeyV4 from 'src/components/InputsDinamicos/UniqueKeyV4';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import useLoading from 'src/hooks/useLoading';
import usePageValidation from 'src/hooks/usePageValidation';
import { setCotizacion } from 'src/reducers/Cotizacion/cotizacion.actions';
import { guardarLead, POST } from 'src/services';
import { setTitularUrl, urlSetBeneficiarios, urlcalcularVigenciaPoliza } from 'src/services/urls';
import useCotizacion from 'src/hooks/useCotizacion';
const tagPage = "paginaTitular"

const RegistroTitularPage = ({ cotizacion, idCotizacion }) => {
  const { values, setLoading, setSecundario, resetLoading } = useLoading();
  const history = useHistory();
  const dispatch = useDispatch();
  const { addErrorToast } = useCustomToast();
  const use_cotizacion = useCotizacion();
  const { update = "" } = useParams<any>();

  const methods = useForm({
    mode: 'onChange',
    defaultValues: cotizacion?.titular || {},
  });

  useEffect(() => {
    if (`${update}` === "true") {
      use_cotizacion.actualizar();
    }
  }, [update]);

  const textos = cotizacion?.configuracion?.textos?.[tagPage] ?? ""

  const [pageProps, setPageProps] = useState({
    goBack: `/preview/${idCotizacion}/${cotizacion?.producto?.id}`,
    subTitle:
      'Por favor ingresa la siguiente información correspondiente a la persona que ejercerá como titular',
    goToSubmit: `/newPaginaCompra/${idCotizacion}`,
    footerButton: {
      className: 'footer_button__continuar',
      classNameContainer: 'footer_container__continuar',
      label: 'Continuar',
      type: 'submit',
    },
    camposTitular: undefined
  });

  const { execEvent, isLoadingCallbacks } = usePageValidation(tagPage);

  const init = useCallback(async () => {
    guardarLead(idCotizacion, 'REGISTRO_TITULAR__INGRESO');
    await execEvent('initCallback', { pageProps, setPageProps, cotizacion }, () => { });
  }, [isLoadingCallbacks]);

  useEffect(() => {
    if (isLoadingCallbacks) return;
    init();

    return () => {
      execEvent('outCallback');
    };
  }, [isLoadingCallbacks]);

  const onSubmit = async (data) => {


    const data2 = {}
    if (pageProps?.camposTitular) {
      pageProps?.camposTitular.forEach(({ codCore }) => {
        console.log("PAGINA TITULAR", codCore)
        data2[codCore] = data[codCore]
      })
      data = { ...data2 }
    }

    let formData = {}

    for (const property in data) {
      if (typeof data[property] === "string")
        formData[property] = data[property].trim();
      else formData[property] = data[property];
    }


    setLoading(true);
    setSecundario('Ingresando al titular...');

    await execEvent(
      'onClickContinuarCallback',
      {
        setLoading,
        setSecundario,
        resetLoading,
        formData,
      },
      async (res, res2) => {

        console.log("RESRES:", res, res2)

        const body = {
          ip: await publicIp.v4(),
          idCotizacion,
          titular: formData,
        };

        if (cotizacion?.beneficiarioIgualTitular) {
          const bodyBeneficiario = {
            beneficiarios: [formData],
            idCotizacion,
          };
          guardarLead(idCotizacion, 'PAGINA_TITULAR__REGISTRO_BENEFICIARIOS');

          // Axios.get(urlcalcularVigenciaPoliza(idCotizacion)).catch((e) =>
          //   addErrorToast('Error calculando vigencia'),
          // );
          const { data } = await Axios.post(urlSetBeneficiarios, JSON.stringify(bodyBeneficiario));

          if (data.transaccion) {
            dispatch(setCotizacion(data.cotizacion));
          }
        }

        const { transaccion, data } = await POST(setTitularUrl, body);

        if (transaccion) {
          dispatch(setCotizacion(data));
          guardarLead(idCotizacion, 'REGISTRO_TITULAR__INGRESO_TITULAR__SUCCESS');
          history.push(pageProps.goToSubmit);
        } else {
          addErrorToast('Ha ocurrido un problema al ingresar el titular');
          guardarLead(idCotizacion, 'REGISTRO_TITULAR__INGRESO_TITULAR__ERROR');
        }
        resetLoading();
      },
    ).finally(() => { console.log("Finally"); resetLoading(); })
      .catch(e => console.log("catch", e));
  };

  const onSubmitError = () => addErrorToast('Hay campos pendientes, por favor revisalos');


  const dataTitular = pageProps?.camposTitular ?? cotizacion.producto.categoria.camposTitular
  console.log("PAGINA TITULAR:", dataTitular)

  return (
    <LoadingWrapper {...values}>
      <DIV stylePath="registroTitular.globalStyles" className="container-fluid container-page">
        <NavbarHeader goBack={pageProps?.goBack} />
        <HeaderPage progreso={40} />
        <FormProvider {...methods}>
          <form noValidate onSubmit={methods.handleSubmit(onSubmit, onSubmitError)}>
            <>
              <div className="row justify-content-center">
                <div className="col-12 col-md-9 col-lg-8 col-xl-7 mt-3">
                  <h4 className="titulo font-weight-bold"> {textos?.titulo ?? 'Ingreso de datos del titular'}</h4>
                  <p className="descripcion">{textos.subTitulo ?? pageProps?.subTitle}</p>
                </div>
              </div>
              <div className="container__form row justify-content-center">
                <div className="subcontainer__form__inputs col-12 col-md-9 col-lg-8 col-xl-7  my-5">
                  <div className="row justify-content-between">
                    <UniqueKeyV4 name="id" defaultValue="" />
                    <InputsDinamicos inputs={dataTitular} />
                  </div>
                </div>
              </div>
              {/*@ts-ignore */}
              <FooterButton {...pageProps?.footerButton} />
            </>
          </form>
        </FormProvider>
      </DIV>
    </LoadingWrapper>
  );
};

export default withCotizacion(RegistroTitularPage);
